'use client';

import React from 'react';

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import MobileNavigation from './MobileNavigation';

interface MobileSideDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Mobile side drawer (hamburger menu).
 * Focuses on browsing navigation (Home, Categories) and Support.
 * Account actions are in the header dropdown.
 */
function MobileSideDrawer({ open, onOpenChange }: MobileSideDrawerProps) {
  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[300px] overflow-y-auto p-0">
        <SheetHeader className="border-b px-6 py-4">
          <SheetTitle className="text-left text-lg font-semibold">Menu</SheetTitle>
        </SheetHeader>
        <div className="px-3">
          <MobileNavigation onClose={handleClose} />
        </div>
      </SheetContent>
    </Sheet>
  );
}

export default MobileSideDrawer;
